import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import { ModalFrame, ModalFrameFooter, ModalFrameMessage } from 'components/modal';

import { __t, applyTranslations } from 'utils/language';

import type { ActiveCampaign } from 'types';

import './profile-rejection-warning.scss';

applyTranslations(require('./profile-rejection-warning.i18n.json'));
applyTranslations(require('locales/common/collabary-common.i18n.json'));

type Props = {
  influencerCampaigns: Array<ActiveCampaign>,
  onCloseModal: () => void,
  onContinue: () => void
};

function getCampaignLink(id: number): string {
  return `/campaigns/${id}/offers`;
}

const ProfileRejectionWarning = (
  {
    influencerCampaigns = [],
    onCloseModal,
    onContinue
  }: Props
): JSX.Element => (
  <ModalFrame
    title={__t('profile_rejection_warning.modal_title')}
  >
    <ModalFrameMessage>
      {__t('profile_rejection_warning.content')}
      <div className="profile-rejection-warning__links">
        {influencerCampaigns.map((campaignData) => (
          <div key={`campaign-link-${campaignData.campaignId}`}>
            <a
              className="profile-rejection-warning__link"
              target="_blank"
              rel="noopener noreferrer"
              href={getCampaignLink(campaignData.campaignId)}
            >
              {campaignData.campaignName}
            </a> by {campaignData.brandName}
          </div>
        ))}
      </div>
    </ModalFrameMessage>

    <ModalFrameFooter>
      <ActionButton
        color="tertiary"
        onClick={onCloseModal}
      >
        {__t('collabary_common.action_button.cancel')}
      </ActionButton>
      <ActionButton
        onClick={onContinue}
      >
        {__t('profile_rejection_warning.submit_label')}
      </ActionButton>
    </ModalFrameFooter>
  </ModalFrame>
);

export default ProfileRejectionWarning;
